// extracted by mini-css-extract-plugin
export var equalColumn = "_gq-0";